import { render, staticRenderFns } from "./CustomerConcentration.vue?vue&type=template&id=75198a50&scoped=true&lang=pug&"
import script from "./CustomerConcentration.vue?vue&type=script&lang=js&"
export * from "./CustomerConcentration.vue?vue&type=script&lang=js&"
import style0 from "./CustomerConcentration.vue?vue&type=style&index=0&id=75198a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75198a50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle})
